import { setBlockType } from 'prosemirror-commands';
import { hasContentInHTMLTags } from 'src/app/common/function';
import { Schema } from 'prosemirror-model';
import {
  AfterContentChecked,
  AfterContentInit,
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { Editor, Toolbar, marks, nodes } from 'ngx-editor';
import { ArticleBlock } from '../../../../models/article';

@Component({
  selector: 'app-article-list',
  templateUrl: './article-list.component.html',
  styleUrls: ['./article-list.component.scss'],
})
export class ArticleListComponent implements OnInit, OnDestroy, AfterViewChecked, OnChanges {
  @Output() blockElementChange = new EventEmitter<ArticleBlock>();

  @Output() openHighLightButtonClick = new EventEmitter<any>();

  @Input() set blockElement(value: ArticleBlock) {
    this._blockElement = value;

    if (this.blockElement.data) {
      let cloneData = this.cleanUpList(this.blockElement.data);
      this.blockElement.cloneData = cloneData;
    }
    if (this.blockElement.data?.trim()) {
      this.schema = new Schema({ nodes: nodes, marks });
    } else {
      this.schema = new Schema({ nodes: nodes, marks, topNode: 'ordered_list' });
    }
    this.editor = new Editor({
      schema: this.schema,
    });

    if (this.blockElement.isDiscardChanges) {
      const highlighArea = document.getElementById(`hightLightArea${this.blockElement?.displayOrder}`);
      if (highlighArea) {
        highlighArea.innerHTML = this.blockElement.data;
        this.blockElement.isDiscardChanges = false;
        this.blockElementChange.emit(this.blockElement);
      }
    }
  }

  cleanUpList(html: string): string {
    const tempdiv = document.createElement('div');
    tempdiv.innerHTML = html;

    let content = '';
    for (let i = 0; i < tempdiv?.children?.length; i++) {
      if (tempdiv?.children[i]?.tagName.toLowerCase() == 'ul') {
        content += this.filterLiContent(tempdiv?.children[i]?.outerHTML, 'ul');
      } else if (tempdiv?.children[i]?.tagName.toLowerCase() == 'ol') {
        content += this.filterLiContent(tempdiv?.children[i].outerHTML, 'ol');
      } else if (tempdiv?.children[i]?.tagName.toLowerCase() == 'p') {
        content += tempdiv?.children[i].outerHTML;
      }
    }

    return content ? content : html;
  }
  schema: any;

  filterLiContent(liHtml: string, listType: string): string {
    const tempdiv = document.createElement('div');
    tempdiv.innerHTML = liHtml;
    let liElements = tempdiv.querySelectorAll('li');

    liElements.forEach(li => {
      if (li) {
        let highlightInsideTag = li.querySelector('p');
        let hightlightText = highlightInsideTag ? highlightInsideTag.innerText : '';

        if (highlightInsideTag && highlightInsideTag.classList.contains('bg-added')) {
          li.innerHTML = `<p>${hightlightText}</p>`;
          li.removeAttribute('id');
        }
      }

      let childListType = listType === 'ul' ? 'ul' : 'ol';
      let childList = li.querySelector(childListType);

      if (childList) {
        let filteredChild = this.filterLiContent(childList.outerHTML, childListType);
        li.innerHTML = li.innerHTML.replace(childList.outerHTML, filteredChild);
      }
    });

    return tempdiv.innerHTML;
  }

  get blockElement() {
    return this._blockElement;
  }

  private _blockElement: ArticleBlock;



  editor: Editor;
  toolbar: Toolbar = [['ordered_list'], ['bullet_list']];

  constructor(private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit(): void {
    this.editor = new Editor({
      schema: this.schema,
    });
  }

  ngOnChanges(): void {
    setTimeout(() => {
      if (this.blockElement?.isActiveForEdit) {
        const editorElement = this.el.nativeElement.querySelector('.ProseMirror.NgxEditor__Content');
        this.renderer.setAttribute(editorElement, 'autofocus', 'true');
        editorElement.focus();
      }
    }, 700);
  }

  ngAfterViewChecked(): void {
    if (this.blockElement.data) {
      const displayHighlighArea = document.getElementById(`displayElement${this.blockElement?.displayOrder}`);
      const highlighArea = document.getElementById(`hightLightArea${this.blockElement?.displayOrder}`);
      if (displayHighlighArea && (displayHighlighArea || highlighArea)) {
        if (displayHighlighArea) {
          displayHighlighArea.innerHTML = this.blockElement?.data;
        }
        if (highlighArea) {
          highlighArea.innerHTML = this.blockElement?.data;
        }
      }
    }
  }

  onChange(e: string) {
    this.blockElement.cloneData = e;
    this.blockElement.data = e;
    this.blockElementChange.emit(this.blockElement);
  }

  addHightLight(e) {
    if (e.target.classList?.contains('btn')) {
      return;
    }
    const id = 'highLight' + Math.floor(Date.now() / 1000).toString();
    const highlightItem = e.target.closest('li');

    if (highlightItem) {
      let highlightInsideTag = highlightItem.querySelector('p');
      let hightlightText = highlightInsideTag.innerText;

      if (highlightInsideTag.classList.contains('bg-added')) {
        const olList = highlightItem.querySelector('ol');
        const ulList = highlightItem.querySelector('ul');
        highlightItem.innerHTML = `<p>${hightlightText}</p>`;
        highlightItem.removeAttribute('id');
        if (olList) {
          highlightItem.appendChild(olList);
        } else if (ulList) {
          highlightItem.appendChild(ulList)
        }
        return;
      }

      //highlightItem.removeChild(highlightInsideTag);
      const listFragment = document
        .createRange()
        .createContextualFragment(
          `<div _ngcontent-ng-c1249821371="" class="cus-tooltip tooltip-effect-1"><p class="tooltip-item bg-added"> ${hightlightText}</p></div>`
        );
      highlightItem.replaceChild(listFragment, highlightInsideTag);
      highlightItem.id = id;

      const buttonFragment = document.createRange().createContextualFragment(`
    <div class="hightLightbox">
    <button class="btn btn-highlight" data-id="${id}" data-title="${hightlightText}">
        <img src="./assets/images/ic-marker.svg" alt="Icon">
        <span>Add highlight</span>
      </button>
      </div>
    `);
      highlightItem.appendChild(
        buttonFragment
      );
    }
  }

  openHighLightModel(e: any) {
    let { id, title } = e.dataset;
    let titleValue = document.querySelector(
      `#${id} .tooltip-content`
    )?.innerHTML;
    if (id) {
      this.openHighLightButtonClick.emit({ id, title, titleValue });
    }
  }

  @HostListener('document:mousedown', ['$event']) onDocumentClick(e: MouseEvent): void {
    const target = e.target as HTMLElement;
    const btn = target.closest('button.btn-highlight');

    if (btn) {
      this.openHighLightModel(btn);
    }
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
